// extracted by mini-css-extract-plugin
module.exports = {"gallery":"gallery-module--gallery--350MN"};